import { SectionTitle } from 'features/ECommerce/screens/AllProducts/AllProducts.styles'
import { useTranslation } from 'hooks/useTranslation'
import { Button } from 'components/Button'
import { ViewAllProductsRoot, Spacer } from './ViewAllProducts.styles'
import blob1 from '../../../../../../../../public/assets/recipes/categories/blob7.png'
import blob2 from '../../../../../../../../public/assets/recipes/categories/blob8.png'
import Image from 'next/image'
import { Blob1, Blob2 } from './ViewAllProducts.styles'
import Link from 'next/link'

export const ViewAllProducts = () => {
  const { t } = useTranslation()

  return (
    <ViewAllProductsRoot>
      <Blob1>
        <Image src={blob1} alt="" />
      </Blob1>
      <Blob2>
        <Image src={blob2} alt="" />
      </Blob2>
      <SectionTitle>{t('products:startr.viewAll.title')}</SectionTitle>
      <Link href='/products'>
        <Button>{t('products:startr.viewAll.cta')}</Button>
      </Link>
    </ViewAllProductsRoot>
  )
}
